import { useDispatch, useSelector } from "react-redux";
import { Product } from "~/types/products";
import {
  setActiveModal,
  setModalProduct,
  setModalData,
  openModalWithProduct,
  openModalWithData,
  closeModal as closeModalAction,
} from "~/redux/actions/modal";
import { selectActiveModal, selectModalProduct, selectModalData, selectIsModalOpen } from "~/redux/selectors/modal";
import { ModalKeys } from "~/constants/modal";
import { AddOnPriceSimplifiedProps } from "~/components/AddOn/simplified/AddOnPriceSimplified";

interface UseModalReturn {
  activeModal: ModalKeys | null;
  modalProduct: Product | null;
  modalData: Record<string, unknown> | null;
  isModalOpen: boolean;
  openModal: (modalKey: ModalKeys) => void;
  openModalWithProduct: (modalKey: ModalKeys, product?: Product, priceComponent?: AddOnPriceSimplifiedProps) => void;
  openModalWithData: (modalKey: ModalKeys, data: Record<string, unknown>) => void;
  closeModal: () => void;
  setModalProduct: (product: Product) => void;
  setModalData: (data: Record<string, unknown>) => void;
}

export const useModal = (): UseModalReturn => {
  const dispatch = useDispatch();

  const activeModal = useSelector(selectActiveModal);
  const modalProduct = useSelector(selectModalProduct);
  const modalData = useSelector(selectModalData);
  const isModalOpen = useSelector(selectIsModalOpen);

  const openModal = (modalKey: ModalKeys) => {
    dispatch(setActiveModal(modalKey));
  };

  const openModalWithProductAction = (
    modalKey: ModalKeys,
    product?: Product,
    priceComponent?: AddOnPriceSimplifiedProps
  ) => {
    dispatch(openModalWithProduct(modalKey, product, priceComponent));
  };

  const openModalWithDataAction = (modalKey: ModalKeys, data: Record<string, unknown>) => {
    dispatch(openModalWithData(modalKey, data));
  };

  const closeModal = () => {
    dispatch(closeModalAction());
  };

  const setModalProductAction = (product: Product) => {
    dispatch(setModalProduct(product));
  };

  const setModalDataAction = (data: Record<string, unknown>) => {
    dispatch(setModalData(data));
  };

  return {
    // State
    activeModal,
    modalProduct,
    modalData,
    isModalOpen,

    // Actions
    openModal,
    openModalWithProduct: openModalWithProductAction,
    openModalWithData: openModalWithDataAction,
    closeModal,
    setModalProduct: setModalProductAction,
    setModalData: setModalDataAction,
  };
};
